import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

// Importation de AOS
import AOS from "aos";
import "aos/dist/aos.css";
import CountryFlag from '@dzangolab/vue-country-flag-icon'
import '@dzangolab/vue-country-flag-icon/dist/CountryFlag.css' // import stylesheet
import Vue3Notification from 'vue3-notification';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Créer l'application
const app = createApp(App);

// Initialiser AOS
app.config.globalProperties.$aos = AOS.init({
  duration: 1000, // Durée des animations
  once: true,     // Animation unique par section
});


// Utiliser le router et le store
app.use(Vue3Notification).use(router).use('CountryFlag', CountryFlag).mount("#app");
